import {
  Dispatch,
  useState
} from 'react';
import {LicenseOrganizationController} from '../../../../api/license/license-organization.controller';
import {LicenseTemplateController} from '../../../../api/license/license-template.controller';
import {
  OrganizationUserController,
} from '../../../../api/organization/organization-user.controller';
import {OrganizationController} from '../../../../api/organization/organization.controller';
import {useAsyncEffect} from '../../../../hook/use-initial-load';
import {FeatureTemplate} from '../../../../model/license/feature-template.model';
import {LicenseDetails} from '../../../../model/license/license-details.model';
import {LicenseFeatureDetails} from '../../../../model/license/license-feature-details.model';
import {OrganizationData} from '../../../../model/organization/organization-data';
import {OrganizationUserLicensePermissionModel} from '../../../../model/organization/organization-user-license-permission.model';
import {OrganizationUserPermissionModel} from '../../../../model/organization/organization-user-permission.model';
import {OrganizationUserModel} from '../../../../model/organization/organization-user.model';

export namespace OrganizationUsersPageHooks {
  export const useOrganizationUsers = (groupId: string): [OrganizationUserModel[], Dispatch<OrganizationUserModel[]>] => {
    const [organizationUsers, setOrganizationUsers] = useState<OrganizationUserModel[]>([]);
    useAsyncEffect(async () => {
      setOrganizationUsers(await fetchOrganizationUsers(groupId))
    }, []);
    return [organizationUsers, setOrganizationUsers];
  }

  export const fetchOrganizationUsers = async (groupId: string): Promise<OrganizationUserModel[]> =>
    (await OrganizationUserController.queryOrganizationUsers(groupId))

  export const useLicenseDetails = (groupId: string): [LicenseDetails | null, Dispatch<LicenseDetails>] => {
    const [licenseDetails, setLicenseDetails] = useState<LicenseDetails | null>(null);
    useAsyncEffect(async () => {
      setLicenseDetails(await fetchLicenseDetails(groupId))
    }, []);
    return [licenseDetails, setLicenseDetails];
  }

  export const fetchLicenseDetails = async (groupId: string) =>
    await LicenseOrganizationController.queryOrganizationLicenseDetails(groupId)


  export const useOrganizationDetails = (groupId: string): [OrganizationData | null, Dispatch<OrganizationData>] => {
    const [organizationDetails, setOrganizationDetails] = useState<OrganizationData | null>(null);
    useAsyncEffect(async () => {
      setOrganizationDetails(await fetchOrganizationDetails(groupId))
    }, []);
    return [organizationDetails, setOrganizationDetails];
  }

  const fetchOrganizationDetails = async (groupId: string): Promise<OrganizationData> =>
    (await OrganizationController.fetchOrganization(groupId))

  export const useFeatureTemplates = (): [FeatureTemplate[], Dispatch<FeatureTemplate[]>] => {
    const [featureTemplates, setFeatureTemplates] = useState<FeatureTemplate[]>([]);
    useAsyncEffect(async () => {
      setFeatureTemplates(await fetchFeatureTemplates())
    }, []);
    return [featureTemplates, setFeatureTemplates];
  }

  const fetchFeatureTemplates = async (): Promise<FeatureTemplate[]> =>
    (await LicenseTemplateController.queryFeatureTemplates())

  export const useLicenseFeatureDetails = (groupId: string): [LicenseFeatureDetails[], Dispatch<LicenseFeatureDetails[]>] => {
    const [licenseFeatureDetails, setLicenseFeatureDetails] = useState<LicenseFeatureDetails[]>([]);
    useAsyncEffect(async () => {
      setLicenseFeatureDetails(await fetchLicenseFeatureDetails(groupId))
    }, []);
    return [licenseFeatureDetails, setLicenseFeatureDetails];
  }

  export const fetchLicenseFeatureDetails = async (groupId: string): Promise<LicenseFeatureDetails[]> =>
    (await LicenseOrganizationController.queryLicenseFeatureDetails(groupId))

  export const useOrganizationUserLicensePermissions = (userId: string): [OrganizationUserLicensePermissionModel[], Dispatch<OrganizationUserLicensePermissionModel[]>] => {
    const [organizationUserPermissions, setOrganizationUserPermissions] = useState<OrganizationUserLicensePermissionModel[]>([]);
    useAsyncEffect(async () => {
      setOrganizationUserPermissions(await fetchOrganizationUserLicensePermissions(userId))
    }, []);
    return [organizationUserPermissions, setOrganizationUserPermissions];
  }

  export const fetchOrganizationUserLicensePermissions = async (userId: string): Promise<OrganizationUserLicensePermissionModel[]> =>
    (await OrganizationUserController.queryOrganizationUserLicensePermissions(userId))

  export const useOrganizationUserPermissions = (userId: string): [OrganizationUserPermissionModel[], Dispatch<OrganizationUserPermissionModel[]>] => {
    const [organizationUserPermissions, setOrganizationUserPermissions] = useState<OrganizationUserPermissionModel[]>([]);
    useAsyncEffect(async () => {
      setOrganizationUserPermissions(await fetchOrganizationUserPermissions(userId))
    }, []);
    return [organizationUserPermissions, setOrganizationUserPermissions];
  }

  export const fetchOrganizationUserPermissions = async (userId: string): Promise<any> =>
    (await OrganizationUserController.queryOrganizationUserPermissions(userId))
}